import { jsx, jsxs } from 'react/jsx-runtime';
import { cva } from 'class-variance-authority';

const menuItemStyles = cva("mci-group mci-flex mci-items-center mci-justify-between mci-duration-fast mci-transition-colors mci-rounded-3", {
    variants: {
        isClickable: {
            true: "hover:mci-bg-gray-200",
            false: "",
        },
    },
});
const UserMenuItem = ({ as, EndAdornmentIcon, isClickable, primaryText, secondaryText, StartAdornmentIcon, ...props }) => {
    const Component = as || "div";
    return (jsx("li", { className: menuItemStyles({ isClickable: Boolean(isClickable) }), children: jsxs(Component, { className: "mci-flex mci-w-full mci-items-center mci-justify-between mci-px-s mci-py-xs -mci-outline-offset-2 mci-outline-brand mci-transition-colors mci-duration-fast", ...props, children: [jsxs("div", { className: "mci-text-start", children: [jsxs("div", { className: "mci-flex mci-items-center", children: [StartAdornmentIcon && (jsx("div", { className: "mci-mr-xs mci-size-[1.25rem]", children: jsx(StartAdornmentIcon, {}) })), jsx("div", { className: "mci-text-body-small mci-font-semibold mci-leading-body", children: primaryText })] }), secondaryText && (jsx("div", { className: "mci-mt-xxs mci-text-body-xsmall mci-leading-body mci-text-gray-700", children: secondaryText }))] }), EndAdornmentIcon && (jsx("div", { className: "mci-size-m", children: jsx(EndAdornmentIcon, { className: "mci-hidden group-hover:mci-block" }) }))] }) }));
};

export { UserMenuItem };
